import React from "react";

const TestimonialCard = ({ testimonial }) => {
	return (
		<div className="bg-gray-400/50 p-4 rounded-sm mb-2 md:w-[50%] w-full">
			<h1 className="text-3xl opacity-50">
				<i className="fa-solid fa-quote-right"></i>
			</h1>
			<p className="text-lg indent-6">{testimonial.des}</p>
			<div className="flex flex-col w-fit mt-3 items-center justify-center">
				<h1 className="text-lg font-semibold">{testimonial.name}</h1>
				<p className="text-md font-semibold opacity-60">
					{testimonial.title}
				</p>
			</div>
		</div>
	);
};

export default TestimonialCard;
